import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { HorizontalRule } from '../../utils/horizontalrule/HorizontalRule';
import Card from './Card';
import { useExternalMedia } from "../../hooks/useExternalMedia";


function Focus() {
	const {  communityDevImg,
        digitalWorkImg,
        economicDevImg} = useExternalMedia()

	  return (
		<section
			id="focus"
			className="section focus-section"
		>
			<Container>

				<HorizontalRule
					text="Focus Areas"
					textColor="#727272"
				/>

				<Row
					className="mt-5"
				>

					<Col
						xs={{ span: 12 }}
						md={{ span: 4 }}
					>
						<Card
							cardText="DIGITAL WORKFORCE"
							cardBg={digitalWorkImg}
						/>
					</Col>

					<Col
						xs={{ span: 12 }}
						md={{ span: 4 }}
					>
						<Card
							cardText="ECONOMIC DEVELOPMENT"
							cardBg={economicDevImg}
						/>
					</Col>

					<Col
						xs={{ span: 12 }}
						md={{ span: 4 }}
					>
						<Card
							cardText="COMMUNITY DEVELOPMENT"
							cardBg={communityDevImg}
						/>
					</Col>

				</Row>

			</Container>

		</section>
	);
}

export default Focus;